/* eslint-disable */
import { Reducer } from 'redux'
import { toast } from 'react-toastify'
import { call, put, takeLatest, all } from 'redux-saga/effects'
import { SagaAction, GetResponse } from 'src/@types'
import { API } from 'src/services/config'
import { AnimalProps } from 'src/@types/Animal'



interface IAnimalGeneticEvaluation {
  acuracia: number | null;
  animal: AnimalProps;
  codigoBarras: string;
  data?: string;
  id: string;
  idAnimal: string;
  idDeps: string;
  idFazenda?: string;
  idFazendaIdAnimal?: string;
  valor?: number | string;
}


export interface GeneticEvaluationState {
  isLoading: boolean,
  list: Array<IAnimalGeneticEvaluation>
}

const customModule = '@GENETIC_EVALUATION'

const GET = {
  REQUEST: `${customModule}/GET_REQUEST`,
  SUCCESS: `${customModule}/GET_SUCCESS`,
}

const SET_FETCHING = `${customModule}/SET_FETCHING`

const initialState: GeneticEvaluationState = {
  isLoading: false,
  list: [],
}

export const geneticEvaluationReducer: Reducer<GeneticEvaluationState> = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET.SUCCESS:
      return { ...state, list: payload, isLoading: false }
    case SET_FETCHING:
      return { ...state, isLoading: payload }
    default:
      return state
  }
}

export const setFetching = (data: boolean) => ({ type: SET_FETCHING, payload: data })
export const getGeneticEvaluation = (farmId: string) => ({ type: GET.REQUEST, payload: farmId })


const ROUTE = '/entity/AnimalDep'

// eslint-disable-next-line
function* get({ payload }: SagaAction<string>) {
  try {
    yield put(setFetching(true))
    const { data }: GetResponse<IAnimalGeneticEvaluation[]> = yield call(API.get, `${ROUTE}/${payload}/null`)

    yield put({ type: GET.SUCCESS, payload: data })
  } catch (error: any) {
    console.error(error)
    const message = error?.response?.data || 'Erro ao buscar avaliação genética do animal. Tente novamente.'
    // toast.error(message)
  } finally {
    yield put(setFetching(false))
  }
}

export const geneticEvaluationSaga = all([
  takeLatest(GET.REQUEST, get),
])
